import "./index.css";

const Modal = (props) => {
  const {
    title,
    refAction,
    firstBtnTxt,
    secondBtnTxt,
    firstBtnAction,
    secondBtnAction,
    closeSetState,
  } = props;
  const cancelModal = () => {
    closeSetState(false);
  };
  return (
    <div className="d-center-popup af-popup-open">
      <div className="d-center-popup-body" ref={refAction}>
        <button
          type="button"
          className="d-center-popup-close-btn"
          onClick={cancelModal}
        >
          <img src="/images/cross-icon.svg" alt="" />
        </button>
        <div className="d-center-popup-title">{title}</div>
        {props.children}
        <div className="d-center-popup-footer-part">
          {firstBtnTxt && (
            <button
              type="button"
              className="d-center-popup-btn send-btn"
              onClick={firstBtnAction && firstBtnAction}
            >
              {firstBtnTxt}
            </button>
          )}
          {secondBtnTxt && (
            <button
              type="button"
              className="d-center-popup-btn cancel-btn"
              onClick={secondBtnAction ? secondBtnAction : cancelModal}
            >
              {secondBtnTxt}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export { Modal };
